import {
  FormGroup,
  FormControl,
  UntypedFormGroup,
  UntypedFormControl
} from '@angular/forms';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { TankSetupService } from 'src/app/services/tank-setup.service';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { TankRtuDeviceService } from 'src/app/services/tank-rtu-device.service';

@Component({
  selector: 'app-min-rtu-lookup-field',
  templateUrl: './min-rtu-lookup-field.component.html',
  styleUrls: ['./min-rtu-lookup-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinRtuLookupFieldComponent implements OnInit {
  @Output() select = new EventEmitter<string | number>();
  @Input() includeAllOrgs: boolean = true;
  @Input() fieldControlName: string;
  @Input() formGroup: FormGroup | UntypedFormGroup;
  @Input() uniqueId: number;
  @Input() disabled: boolean = false;
  @Input() isGateway: boolean = false;

  @ViewChild('rtuListbox') rtuListBox: DropDownListComponent;

  rtuList = [];
  fields = { value: 'text', text: 'text' };
  rtuListDataManager: DataManager = null;
  isFiltering: boolean = false;
  notFilteringPlacholderText = 'TankSwap.Search.Placeholder';
  filteringPlacholderText = 'TankSwap.Searching';

  get searchPlaceHolderText(): string {
    return this.isFiltering
      ? this.filteringPlacholderText
      : this.notFilteringPlacholderText;
  }

  constructor(
    private _tss: TankSetupService,
    private _trds: TankRtuDeviceService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.initFormControl();
  }

  private initFormControl(): void {
    if (this.formGroup && this.fieldControlName) {
      if (!this.formGroup.get(this.fieldControlName)) {
        const control = new FormControl({ value: '', disabled: this.disabled });
        this.formGroup.addControl(this.fieldControlName, control);
      } else {
        const control = this.formGroup.get(this.fieldControlName);
        this.disabled ? control.disable() : control.enable();
      }
    }
  }

  onBeforeOpen($event: any) {
    this.rtuList = [];
  }

  onFiltering($event: any) {
    const minCharToSearch = 4;
    if ($event.text.length >= minCharToSearch) {
      this.rtuListDataManager = this._trds.getMinRtuLookupDM(
        this.includeAllOrgs,
        this.uniqueId,
        this.isGateway
      );
      this.isFiltering = true;
      this.getFilteredRTUList($event);
    } else {
      this.rtuList = [];
      $event.cancel = true;
    }
  }

  private getFilteredRTUList($event: any) {
    this.rtuListDataManager
      .executeQuery(
        new Query().where('text', 'contains', $event.text).take(100),
      )
      .then((e) => {
        this.rtuList = e['result'];

        if (this.rtuList.length === 0) {
          this.select.emit(null);
        }

        setTimeout(() => {
          if (this.rtuListBox.getItems().length === 1) {
            this.rtuListBox.index = 0;
            this.rtuListBox.value = this.rtuList[0].value;
            this.rtuListBox.text = this.rtuList[0].text;
            this.rtuListBox.hidePopup();
            this.selectRTUItem(this.rtuList[0].value);
          }
          this._cdr.markForCheck();
        }, 250);

        this.isFiltering = false;
        this._cdr.markForCheck();
      });
  }

  onSelect($event: any) {
    this.selectRTUItem($event.itemData.value);
  }

  private selectRTUItem(value: string | number) {
    if (this.formGroup && this.fieldControlName) {
      const control = this.formGroup.get(this.fieldControlName);
      if (control) {
        control.setValue(value);
        this.select.emit(value);
      } else {
        console.error(`Form control ${this.fieldControlName} not found in form group`);
      }
    } else {
      console.error('Form group or field control name is not defined');
    }
  }
}
